import {combineReducers} from 'redux';
import {
  GETENTITY,
  LOADCONFIG,
  LOADCURRENCIES,
  LOADCURRENCYQUOTES,
  LOADLISTING,
  LOADLOCATIONS,
  SAVEHOMEPAGEFEATUREDLISTINGS,
  SAVEHEROLISTINGS,
  SAVEPRESS,
  SELECTCURRENCY,
} from '../constants/action-types';
import initialState from '../store/initial-state';
import {routerReducer} from 'react-router-redux';

const reducer = (state = initialState, action) => {
  switch(action.type) {
    case GETENTITY:
      return Object.assign({}, state, { entity: action.entity });
    case SAVEHEROLISTINGS:
      return Object.assign({}, state, { heroListings: action.heroListings });
    case SAVEHOMEPAGEFEATUREDLISTINGS:
      return Object.assign({}, state, { featuredListings: action.featuredListings });
    case SAVEPRESS:
      return Object.assign({}, state, { press: action.press });
    case LOADLISTING:
      return Object.assign({}, state, { listing: action.listing });
    case LOADCONFIG:
      return Object.assign({}, state, { config: action.config });
    case LOADCURRENCIES:
      return Object.assign({}, state, { currencies: action.currencies });
    case LOADCURRENCYQUOTES:
      return Object.assign({}, state, { currencyQuotes: action.currencyQuotes });
    case SELECTCURRENCY:
      return Object.assign({}, state, { selectedCurrency: action.selectedCurrency });
    case LOADLOCATIONS:
      return Object.assign({}, state, { locations: action.locations });
    default:
      return state;
  }
}

const rootReducer = combineReducers({
  routing: routerReducer,
  store: reducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js